export const onBoardingSxs = {
  welcomeBox: {
    textAlign: 'center',
    // marginTop: '6rem',
    marginBottom: '2rem'
  },
  welcomeText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-30)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-38)',
    color: 'var(--color-primary)',
    marginBottom: '8px',
    paddingTop: '6rem'
  },
  description: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-mid)',
    marginBottom: '8px'
  },
  mainPluginBox: {
    display: { xs: 'block', md: 'flex' },
    justifyContent: 'center', // Center the boxes horizontally
    textAlign: 'center',
    // maxWidth: { xs: '100%', md: '64%' },
    maxWidth: '1070px',
    marginLeft: 'auto',
    marginRight: 'auto',
    gap: '10px',
    marginTop: '32px',
    backgroundColor: 'rgba(254, 252, 251, 1)',
    borderRadius: '6px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for card-like appearance
    border: '1px solid rgba(0, 0, 0, 0.1)' // Light border for definition
  },
  tutorialBox: {
    display: 'flex',
    justifyContent: 'center', // Centers content horizontally
    alignItems: 'center', // Centers content vertically
    backgroundColor: 'var(--color-bg-muted-alt)'
  },
  iframeStyle: {
    aspectRatio: '16/9' // Ensures the iframe maintains a 16:9 aspect ratio
  },
  pluginImgSx: {
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  infoBox: {
    padding: '24px'
  },
  installPluginText: {
    fontFamily: 'Inter',
    fontSize: '22px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'center',
    color: 'var(--color-text-muted)',
    marginBottom: '13px'
  },
  pluginDesc: {
    //styleName: Text sm/Regular;
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-tertiary)',
    marginBottom: '26px'
  },
  continueBtn: {
    padding: '12px 18px 12px 18px',
    gap: '8px',
    borderRadius: '6px',
    border: '1px',
    marginTop: '7px',
    marginBottom: '5px'
  },
  installPluginBtn: {
    '&:hover, &:focus, &:active': {
      backgroundColor: 'transparent'
    },
    '& .MuiButton-endIcon': {
      marginLeft: '0px !important'
    }
  },
  northIcon: {
    marginLeft: '4px'
  },
  freePlanContainer: {
    height: 'auto'
  },
  stepperBox: {
    mt: 5, // Margin top
    mb: 4,
    width: '100%',
    height: 'auto',
    // maxWidth: '500px',
    margin: '0 auto',
    textAlign: 'center'
  },
  stepLabelBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  stepNumber: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    border: '2px solid var(--color-secondary)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold'
  },
  stepText: {
    fontWeight: 'bold',
    color: 'var(--color-primary)'
  },
  stepperIcon: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold'
  },
  stepNumSx: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '15.73px',
    textAlign: 'center'
  },
  stepLabelSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 700,
    lineHeight: '15.73px',
    textAlign: 'center'
  },
  stepper: {
    maxWidth: '783px',
    marginLeft: 'auto',
    marginRight: 'auto',
    '& .MuiStepConnector-root': {
      paddingLeft: '15px',
      paddingRight: '15px'
    },
    '& .MuiStepConnector-line': {
      borderColor: 'var(--color-primary) !important',
      borderTopWidth: '2px'
    }
  },
  btnText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-purple)',
    padding: '0px'
  },
  freeLoaderBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh' // Full screen height
  }
};

export const pluginWarningModalSxs = {
  mainBox: {
    padding: '0px 20px 32px 20px'
  },
  descBox: {
    display: 'flex',
    border: '1px solid var(--color-secondary)',
    backgroundColor: 'var(--color-success-bg-ultra)',
    padding: '8px',
    gap: '8px',
    borderRadius: '8px',
    marginBottom: '16px',
    paddingLeft: '5%'
  },
  pluginDesc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-text-dark)'
  },
  desc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    maxWidth: '78%',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  btnBox: {
    marginTop: '32px',
    display: 'flex',
    gap: '10px'
  },
  btn: {
    padding: '10px 18px 10px 18px',
    gap: '8px',
    borderRadius: '6px'
  },
  descErrorBox: {
    display: 'flex',
    border: '1px solid #F97066',
    backgroundColor: 'rgba(249, 112, 102, 0.2)',
    padding: '8px',
    gap: '8px',
    borderRadius: '8px',
    marginBottom: '16px',
    paddingLeft: '5%'
  }
};

export const paidPlanOnBoardingSxs = {
  firstStepMainBox: {
    width: 'fit-content',
    minWidth: { xs: 'fit-content', sm: '32rem' },
    padding: '24px',
    marginLeft: 'auto',
    marginRight: 'auto',
    borderRadius: '6px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for card-like appearance
    border: '1px solid rgba(0, 0, 0, 0.1)',
    backgroundColor: 'var(--color-white)'
  },
  secondStepBox: {
    maxWidth: { xs: '100%', md: '33%' }
  },
  firstStepBtnBox: {
    mt: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5px'
  },
  gscTitle: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'center',
    color: 'var(--color-text-muted)',
    marginBottom: '8px'
  },
  gesDesc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-tertiary)',
    marginBottom: '16px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  watchTutorial: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-primary)',
    cursor: 'pointer'
  },
  shareSquareSpaceIconSx: {
    cursor: 'pointer'
  },
  watchTutorialBox: {
    display: 'inline-flex',
    marginBottom: '32px'
  },
  imgBox: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '32px'
  },
  gscAlertBox: {
    alignItems: 'flex-start'
  },
  gscDesc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  thirdStepBox: {
    display: { xs: 'contents', md: 'flex' },
    width: 'fit-content',
    minHeight: '500px',
    borderRadius: '6px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for card-like appearance
    border: '1px solid rgba(0, 0, 0, 0.1)'
  },
  tutorialBox: {
    backgroundColor: 'rgba(52, 52, 83, 0.14)'
  },
  thirdStepMainBox: {
    display: { xs: 'inline', md: 'inline-flex' },
    maxWidth: '78rem',
    // maxHeight: '35rem',
    minHeight: '36rem',
    backgroundColor: 'var(--color-white)'
  },
  tabsMainBox: {
    width: 'max-content',
    minWidth: '100%'
  },
  tabSx: {
    minWidth: '-webkit-fill-available'
  },
  firstSiteBox: {
    padding: '24px'
  },
  setupMonitoringSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    marginBottom: '14px'
  },
  setupMonitoringDescSx: {
    //styleName: Text sm/Regular;
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)',
    marginBottom: '16px'
  },
  frequencySx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-text-dark)',
    marginBottom: '8px'
  },
  btnBox: {
    display: 'flex',
    gap: '8px',
    marginBottom: '115px'
  },
  btn: {
    padding: '12px 18px 12px 18px',
    gap: '6px',
    borderRadius: '6px',
    // borderColor: 'var(--color-text-muted-purple)',
    '&:hover': {
      backgroundColor: 'rgba(37, 211, 177, 0.4)',
      borderColor: 'var(--color-secondary)'
    }
  },
  tabs: {
    // borderRight: 1,
    // borderColor: 'divider',
    border: '1px solid transparent',
    borderRadius: '12px 0px 0px 12px',
    marginTop: '25%',

    '& .MuiTabs-indicator': {
      display: 'none' // Hides the indicator
    }
  },
  monitoringTab: {},
  skipPagesTab: {},
  monitoringLabel: {
    textTransform: 'none',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    marginRight: 'auto'
    // color: 'var(--color-white)'
  },
  required: {
    textTransform: 'none',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    marginRight: 'auto'
    // color: 'var(--color-border)'
  },
  startJourneySx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'center',
    color: 'var(--color-text-muted)',
    marginBottom: '8px'
  },
  addYourSiteDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-tertiary)',
    marginBottom: '26px'
  },
  enterSiteLabelSx: {
    padding: '0px',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left'
  },
  enterSiteInputProps: {
    backgroundColor: 'var(--color-white)',
    marginTop: '0px',
    '& .MuiInputBase-input': {
      padding: '0px'
    },
    '& .MuiOutlinedInput-root': {
      paddingTop: '10px',
      paddingBottom: '10px',
      paddingLeft: '14px',
      paddingRight: '14px',
      borderRadius: '6px'
    }
  },
  continueBtnSx: {
    padding: '12px 18px 12px 18px',
    gap: '8px',
    borderRadius: '6px',
    border: '1px',
    opacity: '0px'
  },
  skipOnBoardingBtnSx: {
    width: 'auto',
    '&:hover': {
      backgroundColor: 'transparent' // Remove hover background color
    }
  },
  skipOnBoardingBtnTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-purple)'
  },
  loaderSx: {
    color: 'white'
  },
  lockIconMainBox: {
    width: '100%',
    position: 'relative',
    display: 'inline-block'
  },
  lockIconBox: {
    zIndex: 10,
    position: 'absolute',
    right: '6%', // Adjust this value as needed to position the image half inside and half outside
    top: '0%', // Vertically center the image
    transform: 'translateY(-50%)'
  },
  gscErrorGscText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'rgba(249, 112, 102, 1)'
  },
  selectSiteBox: (isLocalSeo: boolean) => ({
    width: 'fit-content',
    minWidth: { xs: 'fit-content', sm: isLocalSeo ? '600px' : '32rem' },
    maxWidth: isLocalSeo ? '600px' : '32rem',
    padding: '24px',
    marginLeft: 'auto',
    marginRight: 'auto',
    borderRadius: '6px',

    marginTop: '1rem',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for card-like appearance
    border: '1px solid rgba(0, 0, 0, 0.1)',
    backgroundColor: 'var(--color-white)'
  }),

  selectSiteTitle: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'center',
    color: 'var(--color-text-muted)'
  },
  selectSiteDescription: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'center',
    // color: 'var(--color-white)'
    color: 'var(--color-text-tertiary)',
    marginTop: '4px'
    //styleName: Text xs/Regular;
  },
  connectButton: {
    marginTop: '8px',
    padding: '10px 18px 10px 18px',
    // backgroundColor: 'var(--color-secondary)',
    backgroundColor: 'var(--color-primary)',
    // color: 'var(--color-primary)', // Blue text color
    color: 'var(--color-white)', // white text color
    '&:hover': {
      backgroundColor: 'var(--color-primary)' // Slightly darker green on hover without glow
      // color: 'rgba(18, 2, 66, 0.9)' // Slightly darker blue text on hover
    },
    transition: 'background-color 0.3s ease, color 0.3s ease' // Smooth transition for background and text color
  },
  avatarBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px'
  },
  connectBtnTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center'
  },
  squareSpaceLoaderBoxSx: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh', // Full viewport height to center vertically
    width: '100vw', // Full viewport width to center horizontally
    position: 'fixed', // Ensures it stays fixed to the viewport
    top: 0,
    left: 0,
    zIndex: 1300 // Higher z-index to overlay other content
  },
  skipPagesTitleBoxSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  },
  skipPagesChipBoxSx: {
    padding: '6px 12px 6px 12px',
    gap: '4px',
    borderRadius: '100px',
    display: 'flex',
    alignItems: 'center'
  },
  skipChipLabel: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  skipChipSpanLabel: {
    fontSize: 'var(--font-size-16)',
    fontWeight: 600
  },
  imgBoxSx: {
    width: '16px',
    height: '16px'
  },
  lockIconBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    background: 'var(--color-secondary)',
    padding: '4px 8px 4px 8px',
    borderRadius: '100px',
    cursor: 'pointer'
  },
  lockImgSx: {
    cursor: 'pointer'
  },
  unlockTextSx: {
    cursor: 'pointer',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  thirdSiteBox: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  imgOptionSelector: {
    '& .MuiSelect-select': {
      justifyContent: 'space-between',
      paddingTop: '10px',
      paddingRight: '14px',
      paddingBottom: '10px',
      paddingLeft: '14px',
      borderRadius: '6px',
      borderWidth: '1px',
      border: '1px solid var(--color-border-muted)',
      textAlign: 'left'
    },
    '& .MuiInputBase-root': {
      borderRadius: '6px',
      textAlign: 'left'
    }
  },
  formControlSx: {
    '& .MuiInputBase-root': {
      borderRadius: '6px',
      textAlign: 'left',
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: 'var(--font-size-16)',
      lineHeight: 'var(--line-height-24)',
      color: 'var(--color-text-darkest)'
    },
    '& .MuiPaper-root': {
      borderRadius: '6px'
    }
  },
  menuTextSx: {
    textAlign: 'left',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-darkest)',
    display: 'inline-block'
  },
  connectButtonBox: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

export const onBoardingNavbarSx = {
  toolbar: {
    backgroundColor: 'var(--color-white)'
  },
  imgBtnSx: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  spacerBox: {
    flexGrow: 1
  },
  rightSideBoxSx: {
    display: 'flex',
    alignItems: 'center'
  },
  imgBtnBox: {
    height: '50px', // Match the desired image height
    width: '140px', // Match the desired image width
    display: 'flex', // Center the image
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden' // Ensure the image stays within bounds
  },
  appBarSx: {
    boxShadow: '0px 4px 6px -1px rgba(52, 52, 83, 0.12)'
  },
  logoBtn: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
};

export const skipOnBoardingSx = {
  mainBox: {
    padding: '0px 12px 24px 12px'
  },
  skipOnBoardingTextSx: {
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-primary)',
    marginBottom: '16px'
  },
  skipDescSx: {
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginBottom: '32px',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '266px'
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px'
  },
  btnSx: {
    padding: '10px 18px 10px 18px',
    gap: '8px',
    borderRadius: '6px'
  },
  btnText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)'
  }
};

export const MultipleLanguageModalCss = {
  mainBox: {
    padding: '24px'
  },
  btnSx: {
    maxHeight: '44px',
    marginTop: '8px'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 600,
    color: '#000000de'
  },
  descSx: {
    letterSpacing: '0.2px',
    lineHeight: '26px',
    fontFamily: 'Inter',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 400,
    fontSize: 'var(--font-size-15)',
    marginBottom: '12px'
  },
  languageTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    color: 'var(--color-primary)'
  }
};
